<template>
    <div class="o-hidden">
        <div class="h-50 pv5">
            <div class="flex flex-column items-center w-100">
                <div class="w-40-l flex flex-column items-center" style="z-index:100">
                    <div class="pulse slide-up w-30-ns w-50 relative pointer" @mouseleave="animate" @touchend="animate">
                        <img src="../assets/lcamero.png" id="lcamero-logo" alt="Luis Camero Logo" class="w-100">
                    </div>
                    <div class="slide-up pl4-l ph3 tc">
                        <p class="f2 lh-copy" v-if="count == 0">Hello There. <span class='fade-in-3 b'>I'm Luis</span><br><span class='fade-in-5'>and I'm a <span class='b red'>Web Artisan</span></span></p>
                        <!-- <p class="f2 lh-copy" v-if="count == 1">Would you like to get a conversation going? <span class='fade-in-3 b'>Click.</span></p>
                        <p class="f2 lh-copy" v-if="count == 2">No? That's okay.<br><span class='fade-in-3 b'>I'm here if you need anything.</span></p> -->
                    </div>
                </div>
                <div class="pa4 w-100 absolute vh-50 mt6 mt3-l fade-in-5" style="z-index:10">
                    <rain-component left="5" start="5000" color="b--purple" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="10" start="5000" color="b--light-red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="15" start="5000" color="b--red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="20" start="5000" color="b--red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="25" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="27" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="30" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="35" start="5000" color="b--light-silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="40" start="5000" color="b--light-silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="43" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="45" start="5000" color="b--light-silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="50" start="5000" color="b--light-silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="55" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="60" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="65" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="67" start="5000" color="b--silver" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="70" start="5000" color="b--red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="75" start="5000" color="b--red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="88" start="5000" color="b--red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="80" start="5000" color="b--red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="85" start="5000" color="b--light-red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="87" start="5000" color="b--light-red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="90" start="5000" color="b--light-red" :bottom="offsetY" :trans="transition"></rain-component>
                    <rain-component left="95" start="5000" color="b--purple" :bottom="offsetY" :trans="transition"></rain-component>
                    <!-- <div class="bw2 bl b--silver h2 absolute transition" :style="{'bottom' : bottom + '%', 'opacity' : opacity}"></div> -->
                    <!-- <div class="w-10 mr1 ml1 h1 bg-silver tr-1 mt4 absolute bottom-0">1</div> -->
                </div>
            </div>
        </div>
        <div class="h-25 near-black fade-in-8 tl ph3 pb4 ph4-l bg-near-white mt6-l mt3 flex flex-column items-center relative" style="z-index:20">
            <hr class="w-80 w-60-l bb bw1 b--black-10">
            <p class="f-subheadline-ns f1 mb3 mt5-l">Everyone has a story...</p>
            <p class="lh-copy f4 w-60-l pb2">I started my journey with a passion for technology and I've learned quite a few things along the way. I'm an Information Engineer who enjoys developing solutions for the web. I follow a path of excellence in everything I do keeping a motivated mindset. Team work is my flag, so I value honesty and respect with great care.</p>
            <i class="fas fa-angle-down near-black mt4-l mb4 f1-l f2 hidden hidden-bottom" v-infocus="'showElement'"></i>
        </div>
        <div class="h-75 bg-white fade-in-8 flex-l justify-center-l items-center-l relative" style="z-index:20">
            <div class="w-30-l near-black mb4 tl hidden hidden-left pt4" v-infocus="'showElement'">
                <p class="f-subheadline-ns f1 ph3 mb3">Skills <span class="f1-l f3 moon-gray">&lt;/dev&gt;</span></p>
                <p class="lh-copy black w-90-l pa3 b">My main area of expertise is web development. I enjoy working on front-end and back-end altogether to create awesome applications. I've come across quite a few technologies through my career and I'm eager to keep learning. Linux, Windows, frameworks, virtualization, IoT, web development, raspberry pi... It's all about creating great things!</p>
            </div>
            <div class="w-30-l ph3 pa0-l pb4 ml5-l hidden hidden-right" v-infocus="'showElement'">
                <div v-for="skill in skills" :key="skill.key" class="w-100 mt3">
                    <div class="relative">
                        <div class="absolute br-pill w-100 bg-light-gray h2"></div>
                        <div class="relative bg-main-red h2 br-pill" :class="skill.level">
                            <p class="fl white pl3 pt2 mr4-l mt0 mb0"><strong>{{ skill.skill }}</strong></p>
                            <i class="white fr f4 pr3 pt2" :class="skill.icon"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-100 bg-near-black pt4 flex-l flex-column items-center fade-in-8">
            <p class="f-subheadline-ns f1 pl3 pr3 pl4-l pr4-l w-100 near-white tl">Work Experience</p>
            <div class="w-80-l pa3 flex mt5">
                <div class="w-30 dn flex-l flex-column-l items-center-l mt6">
                    <div class="h1 w1 br-pill ba b--red mt2"></div>
                    <div class="h5 bl b--near-white"></div>
                    <div class="h1 w1 br-pill ba b--red"></div>
                    <div class="h5 bl b--near-white"></div>
                    <div class="h1 w1 br-pill ba b--red"></div>
                </div>
                <div class="w-70-l near-white">
                    <div>
                        <p class="f3-l f4 tl mt0 mb0 b">Software Engineering Team Lead</p>
                        <p class="red tl f6">Jan 2017 - Current</p>
                        <p class="lh-copy tl w-80-l mt3">CIP Reporting is a risk management and incident reporting company, born in Washington DC. I serve as a back-end developer for the costa rican branch of CIP Reporting and help on the growth of its reporting platform. I work mostly with back-end technologies throught the platform but like to help on as many front-end projects as I can (I developed their costa rican website for example: <a target="blank" class="white" href="http://cipreporting.co.cr">check it out!</a>). PHP and Javascript are the languages I use the most here and work on things from creating forms, integrations and views to file processing and API development.</p>
                        <p class="f6 silver tl">CIP Reporting</p>
                    </div>
                    <div class="mt5">
                        <p class="f3-l f4 tl mt0 mb0 b">Engineering Internship</p>
                        <p class="red tl f6">Jan 2015 - Apr 2015</p>
                        <p class="lh-copy tl w-80-l mt3">EPA is a multinational retail store located in latin america, born in Venezuela. I worked at the software department on the creation of virtualized environments for development and testing. Using tools such as Vagrant, I was able to encapsulate a Linux environment in a easy to distribute box that promoted automation to help the development team use a controlled environment for development and testing of propietary applications.</p>
                        <p class="f6 silver tl">EPA</p>
                    </div>
                    <div class="mt5">
                        <p class="f3-l f4 tl mt0 mb0 b">Leader & Tutor - Marketing</p>
                        <p class="red tl f6">Apr 2013 - Dec 2016</p>
                        <p class="lh-copy tl w-80-l mt3">Vida UNITEC is a program for new students at my university, UNITEC. I performed tutoring activities about creativity, projects and branding. I started my work there creating classes for junior students and walked my way up until I became one of the group leaders, specifically in the marketing area where week after week we would create campaigns through social media and activities for students. I also created Vida UNITEC's website at that time for informational purposes and also an internal dashboard to manage student data, grades, attendance and group members information. <router-link to="/vidaunitec" class="white">check it out!</router-link></p>
                        <p class="f6 silver tl">Vida UNITEC - University</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RainComponent from './rain-component'

export default {
  components: {
    RainComponent
  },
  data: function () {
    return {
      transition: 10,
      offsetY: 0,
      count: 0,
      skills: [
        {
          'key': 1,
          'skill': 'PHP',
          'level': 'w-80',
          'icon': 'fab fa-php'
        },
        {
          'key': 2,
          'skill': 'Javascript',
          'level': 'w-70',
          'icon': 'fab fa-js'
        },
        {
          'key': 3,
          'skill': 'CSS',
          'level': 'w-80',
          'icon': 'fab fa-css3-alt'
        },
        {
          'key': 4,
          'skill': 'Vue',
          'level': 'w-60',
          'icon': 'fab fa-vuejs'
        },
        {
          'key': 5,
          'skill': 'Git',
          'level': 'w-70',
          'icon': 'fab fa-git-square'
        },
        {
          'key': 6,
          'skill': 'Laravel',
          'level': 'w-70',
          'icon': 'fab fa-laravel'
        },
        {
          'key': 7,
          'skill': 'Tachyons',
          'level': 'w-80',
          'icon': 'far fa-object-group'
        },
        {
          'key': 8,
          'skill': 'Bootstrap',
          'level': 'w-70',
          'icon': 'fas fa-boxes'
        },
        {
          'key': 9,
          'skill': 'Webpack',
          'level': 'w-50',
          'icon': 'fas fa-cube'
        },
        {
          'key': 10,
          'skill': 'Photoshop',
          'level': 'w-60',
          'icon': 'fas fa-paint-brush'
        },
        {
          'key': 11,
          'skill': 'Vagrant',
          'level': 'w-50',
          'icon': 'fas fa-server'
        }
      ]
    }
  },
  methods: {
    // animate: function () {
    //   this.count === 2 ? this.count = 0 : this.count = this.count
    //   this.count++
    // },
    animate: function () {
      console.log('animate')
    }
    // mouse: function (event) {
    //     this.offsetY = event.offsetY
    //     this.transition = .5
    // }
  },
  directives: {
    infocus: {
      isLiteral: true,
      inserted: (el, binding, vnode) => {
        let f = () => {
          let rect = el.getBoundingClientRect()
          let inView = (
            rect.width > 0 &&
            rect.height > 0 &&
            rect.top >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          )
          if (inView) {
            el.classList.add(binding.value)
            window.removeEventListener('scroll', f)
          }
        }
        window.addEventListener('scroll', f)
        f()
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue